import React from "react";
import QuotationSelectedComponent from "./quotation-selected.component";

const QuotationSelectedContainer = () => {
  return <QuotationSelectedComponent />;
};

export default QuotationSelectedContainer;
